import axios from "axios";

const baseUrl = '/api/legend';

export const getLegendHeaderDescription = (layerId) => axios.get(`${baseUrl}/header/${layerId}`)
export const getLegendFooterDescription = (layerId) => axios.get(`${baseUrl}/footer/${layerId}`)
export const getLegendValueDescription = (layerId) => axios.get(`${baseUrl}/value/${layerId}`)
